import { render, staticRenderFns } from "./LightEquipmentView.vue?vue&type=template&id=a127a330&scoped=true"
import script from "./LightEquipmentView.vue?vue&type=script&lang=js"
export * from "./LightEquipmentView.vue?vue&type=script&lang=js"
import style0 from "./LightEquipmentView.vue?vue&type=style&index=0&id=a127a330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a127a330",
  null
  
)

export default component.exports